import React from 'react'
import styled from 'styled-components'
import Accordion from '@pcln/accordion'
import { Box, Flex, Text } from 'pcln-design-system'
import {
  CalendarIcon,
  ParentFlex,
  StyledAccordionTrigger,
  TriggerWrapper,
} from './FlexDatesCollapsibleContainer.styles'

const Content = styled(Accordion.Content)`
  padding-top: 24px;
`

export interface IFlexDatesCollapsibleContainer {
  className?: string
  title: string
  subTitle: string
  isOpen: boolean
  children: React.ReactNode,
  onClose?: () => void
}

/** @public */
const FlexDatesCollapsibleContainer: React.FC<IFlexDatesCollapsibleContainer> = ({
  title,
  subTitle,
  isOpen,
  children,
  onClose,
  ...props
}: IFlexDatesCollapsibleContainer) => (
  <ParentFlex flexDirection='column' color='background.light' borderRadius='xl' pt={3} {...props}>
    <Accordion open={isOpen}>
      <TriggerWrapper mt={2}>
        <StyledAccordionTrigger size={24} color='primary.base' onClose={onClose}>
          <Flex justifyContent='space-between' px={3}>
            <Flex alignItems='center'>
              <CalendarIcon color='primary' bg='white' width='40px' height='40px' />
              <Box ml='12px'>
                <Text color='text.base' bold>
                  {title}
                </Text>
                <Text color='text.base' fontSize={1} mt='2px'>
                  {subTitle}
                </Text>
              </Box>
            </Flex>
          </Flex>
        </StyledAccordionTrigger>
      </TriggerWrapper>
      <Content>{children}</Content>
    </Accordion>
  </ParentFlex>
)

export default FlexDatesCollapsibleContainer
